<template>
  <div>
    <router-view />

    <v-snackbar v-model="getSnackbar.showSnackbar"
                :color="getSnackbar.color"
                :timeout="timeout"
                width="500px"
    >

      <template v-slot:action="{ attrs }">
        <v-btn
          color="indigo"
          text
          v-bind="attrs"
          @click="snackBarAction({showSnackbar:false})"
          style="font-family: anjoman !important;font-weight: normal!important;"
        >
          خروج
        </v-btn>
      </template >
      <div style="font-family: anjoman !important;font-weight: normal!important;">
      {{getSnackbar.textSnackBar}}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
  import {mapGetters , mapActions} from 'vuex'
  import {getUsers} from "./api/users";

  export default {
    name: 'App',
    data:()=>({
      timeout:3000
    }),
    computed:{
      ...mapGetters({
        getSnackbar : 'snackBar/getSnackbar'
      })
    },
    methods:{
      ...mapActions({
        snackBarAction: 'snackBar/snackBarAction'
      })
    },
    mounted() {
      // getUsers(1,4)
    }
    // mounted() {
    //   this.snackBarAction({
    //     showSnackbar:false,
    //     color : '#ff0000',
    //     textSnackBar: 'متاسفانه تغییرات اعمال نشد ',
    //   })
    // }

  }
</script>

<style>
  @font-face {
    font-family: anjoman;
    src:
      url("./assets/fonts/woff/Anjoman-Black.woff");
    font-weight: 900;
  }
  @font-face{
    font-family: anjoman;
    src:
       url("./assets/fonts/woff/Anjoman-Bold.woff");
    font-weight: bold;
  }
  @font-face{
    font-family: anjoman;
     src: url("./assets/fonts/woff/Anjoman-Regular.woff");
    font-weight: normal;
  }
  @font-face{
    font-family: anjoman;
    src:
       url("./assets/fonts/woff/Anjoman-Thin.woff");
    font-weight: 200;
  }
  @font-face {
    font-family: ApercuBold;
    src: url("./assets/fonts/ApercuArabicPro-Bold.ttf") format('ttf'),
    url("./assets/fonts/ApercuArabicPro-Bold.woff") format('woff'),
    url("./assets/fonts/ApercuArabicPro-Bold.woff2") format('woff2'),
    url("./assets/fonts/ApercuArabicPro-Bold.eot") format('eot');
    font-weight: bold;
  }

  @font-face {
    font-family: ApercuLight;
    src: url("./assets/fonts/ApercuArabicPro-Light.ttf") format('ttf'),
    url("./assets/fonts/ApercuArabicPro-Light.woff") format('woff'),
    url("./assets/fonts/ApercuArabicPro-Light.woff2") format('woff2'),
    url("./assets/fonts/ApercuArabicPro-Light.eot") format('eot');
  }
  @font-face {
    font-family: ApercuMedium;
    src: url("./assets/fonts/ApercuArabicPro-Medium.ttf") format('ttf'),
    url("./assets/fonts/ApercuArabicPro-Medium.woff") format('woff'),
    url("./assets/fonts/ApercuArabicPro-Medium.woff2") format('woff2'),
    url("./assets/fonts/ApercuArabicPro-Medium.eot") format('eot');
  }
  @font-face {
    font-family: ApercuRegular;
    src: url("./assets/fonts/ApercuArabicPro-Regular.ttf") format('ttf'),
    url("./assets/fonts/ApercuArabicPro-Regular.woff") format('woff'),
    url("./assets/fonts/ApercuArabicPro-Regular.woff2") format('woff2'),
    url("./assets/fonts/ApercuArabicPro-Regular.eot") format('eot');
  }
  .v-application {font-family: anjoman !important;}

</style>
